import React from "react";

const MContext = React.createContext();

const AppContext = (props) => {
  return <MContext.Provider value={props.value}>{props.children}</MContext.Provider>;
};

export default AppContext;
